import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser, setUser } from "../api/auth";
import api from "../api/axios";
import { useToast } from "../context/ToastContext";

const Profile = () => {
    const userDetail = getUser();
    const navigate = useNavigate();
    const { success, error } = useToast();

    const [formData, setFormData] = useState({
        user_name: "",
        email: "",
        mobile: "",
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!userDetail) {
            navigate("/auth/signin");
            return;
        }

        getUserProfile();

        window.scrollTo(0, 0);
    }, []);

    const getUserProfile = async () => {
        try {
            const response = await api.get("/auth/profile");
            if (response?.data?.success) {
                const pData = response?.data?.data;
                setFormData({
                    user_name: pData?.user_name || "",
                    email: pData?.email || "",
                    mobile: pData?.mobile || "",
                });
            }
        } catch (error) {

        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        // Name Validation
        if (!formData.user_name.trim()) {
            newErrors.user_name = "Full name is required";
        }

        // Email Validation
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
        ) {
            newErrors.email = "Invalid email address";
        }

        // Phone Validation
        if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile)) {
            newErrors.mobile = "Mobile number must be 10 digits";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            setLoading(true);

            const response = await api.put(
                "/auth/update-profile",
                formData
            );

            if (response?.data?.success) {
                success("Profile updated successfully");
            }
        } catch (err) {
            console.error("Update Profile Error:", err);

            error(
                err?.response?.data?.message ||
                "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6">

            {/* Page Header */}
            <div className="mb-6">
                <h1 className="premium-page-title">
                    Profile
                </h1>

                <p className="text-gray-500 text-sm mt-1">
                    Manage your personal information and account details.
                </p>
            </div>

            {/* Content Card */}
            <form
                onSubmit={handleSubmit}
                className="bg-white shadow-sm border border-gray-100 rounded-2xl p-6"
            >

                {/* Avatar Section */}
                <div className="flex items-center gap-6 mb-8">
                    <div className="relative">
                        <div className="w-24 h-24 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 text-white flex items-center justify-center text-3xl font-bold">
                            {formData?.user_name?.charAt(0)?.toUpperCase()}
                        </div>
                    </div>

                    <div>
                        <h2 className="text-lg font-medium text-gray-800">
                            {formData?.user_name}
                        </h2>

                        <p className="text-sm text-gray-500">
                            {userDetail?.role}
                        </p>
                    </div>
                </div>

                {/* Form */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    {/* Full Name */}
                    <div>
                        <label className="text-sm text-gray-600">
                            Full Name
                        </label>

                        <input
                            type="text"
                            name="user_name"
                            placeholder="John Doe"
                            value={formData.user_name}
                            onChange={handleChange}
                            className="w-full mt-1 px-4 py-3 border border-gray-200 rounded-xl focus:ring-1 focus:ring-black focus:border-black outline-none"
                        />

                        {errors.user_name && (
                            <p className="text-red-500 text-sm mt-1">
                                {errors.user_name}
                            </p>
                        )}
                    </div>

                    {/* Email */}
                    <div>
                        <label className="text-sm text-gray-600">
                            Email
                        </label>

                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            disabled
                            className="w-full mt-1 px-4 py-3 border border-gray-200 rounded-xl bg-gray-50"
                        />

                        {errors.email && (
                            <p className="text-red-500 text-sm mt-1">
                                {errors.email}
                            </p>
                        )}
                    </div>

                    {/* Phone */}
                    <div>
                        <label className="text-sm text-gray-600">
                            Phone
                        </label>

                        <input
                            type="text"
                            name="mobile"
                            placeholder="Enter mobile number"
                            value={formData.mobile}
                            onChange={handleChange}
                            maxLength={10}
                            className="w-full mt-1 px-4 py-3 border border-gray-200 rounded-xl focus:ring-1 focus:ring-black focus:border-black outline-none"
                        />

                        {errors.mobile && (
                            <p className="text-red-500 text-sm mt-1">
                                {errors.mobile}
                            </p>
                        )}
                    </div>

                </div>

                {/* Button */}
                <div className="mt-8 flex justify-center">
                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-black text-white !px-7 !py-3 rounded-xl transition dashboard-btn-new disabled:opacity-70"
                    >
                        {loading ? "Saving..." : "Save Changes"}
                    </button>
                </div>

            </form>
        </div>
    );
};

export default Profile;